const initialState = {
    anchor: 'left',
    touro: [],
    open: false,
    id: '',
    nome: '',
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
    codigo: '',
    id_raca: '',
    semen: '',
    brinco: '',
    id_fazenda: ''
};

export function touro(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_TOURO':
            return {
                ...state,
                touro: action.touro
            };
        case 'TOURO_DETAIL':
            return {
                ...state,
                id: action.id,
                nome: action.nome,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
                codigo: action.codigo,
                id_raca: action.id_raca,
                semen: action.semen,
                brinco: action.brinco,
                id_fazenda: action.id_fazenda
            };
        case 'TOURO_CLEAR':
            return {
                ...state,
                anchor: 'left',
                touro: [],
                open: false,
                id: '',
                nome: '',
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
                codigo: '',
                id_raca: '',
                semen: '',
                brinco: '',
                id_fazenda: ''
            };
        case "TOURO_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
